import { render, staticRenderFns } from "./individualizationReport.vue?vue&type=template&id=c0fc67d2&scoped=true"
import script from "./individualizationReport.vue?vue&type=script&lang=js"
export * from "./individualizationReport.vue?vue&type=script&lang=js"
import style0 from "./individualizationReport.vue?vue&type=style&index=0&id=c0fc67d2&prod&lang=scss&scoped=true"
import style1 from "./individualizationReport.vue?vue&type=style&index=1&id=c0fc67d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fc67d2",
  null
  
)

export default component.exports